export default {
  // 页面标题和面包屑
  'pages.moveout.title': 'Move-out Registration Management',
  'pages.moveout.breadcrumb.person': 'Personnel Management',
  'pages.moveout.breadcrumb.moveout': 'Move-out Registration',

  // 副标题配置
  'pages.moveout.subtitle.canEnterEarly': 'After approval, you can enter',
  'pages.moveout.subtitle.hoursEnter': 'hours early, if it exceeds',
  'pages.moveout.subtitle.hoursCannotEnter': 'hours, you will not be able to enter the community',

  // 按钮
  'pages.moveout.button.settings': 'Settings',

  // 标签页
  'pages.moveout.tabs.registered': 'Registered',
  'pages.moveout.tabs.inProgress': 'In Progress',
  'pages.moveout.tabs.completed': 'Completed',

  // 模态框
  'pages.moveout.modal.config.title': 'Move-out Time Configuration',
  'pages.moveout.modal.config.save': 'Save',
  'pages.moveout.modal.config.cancel': 'Cancel',

  // 表单标签
  'pages.moveout.form.beforeHours.label': 'Early Entry Time (Hours)',
  'pages.moveout.form.beforeHours.placeholder': 'Please enter early entry time',
  'pages.moveout.form.beforeHours.required': 'Please enter early entry time',
  'pages.moveout.form.beforeHours.range': 'Please enter a number between 0-24',

  'pages.moveout.form.afterHours.label': 'Timeout Limit (Hours)',
  'pages.moveout.form.afterHours.placeholder': 'Please enter timeout limit',
  'pages.moveout.form.afterHours.required': 'Please enter timeout limit',
  'pages.moveout.form.afterHours.range': 'Please enter a number between 1-168',

  // 消息
  'pages.moveout.message.configUpdateSuccess': 'Configuration updated successfully',
  'pages.moveout.message.configUpdateFailed': 'Configuration update failed',

  // 表格相关
  'pages.moveout.table.title': 'Move-out Registration Management',
  'pages.moveout.table.columns.houseInfo': 'Property Information',
  'pages.moveout.table.columns.applicantName': 'Applicant Name',
  'pages.moveout.table.columns.applicantPhone': 'Applicant Phone',
  'pages.moveout.table.columns.qrcode': 'QR Code',
  'pages.moveout.table.columns.ownerName': 'Owner Name',
  'pages.moveout.table.columns.startDate': 'Move-out Start Date',
  'pages.moveout.table.columns.endDate': 'Move-out End Date',
  'pages.moveout.table.columns.status': 'Status',
  'pages.moveout.table.columns.moveoutList': 'Move-out List',
  'pages.moveout.table.columns.createdTime': 'Created Time',
  'pages.moveout.table.columns.action': 'Action',

  // 按钮
  'pages.moveout.button.create': 'New Move-out Registration',
  'pages.moveout.button.view': 'View',
  'pages.moveout.button.edit': 'Edit',
  'pages.moveout.button.delete': 'Delete',
  'pages.moveout.button.batchDelete': 'Batch Delete',
  'pages.moveout.button.close': 'Close',

  // 状态
  'pages.moveout.status.notStarted': 'Not Started',
  'pages.moveout.status.inProgress': 'In Progress',
  'pages.moveout.status.completed': 'Completed',
  'pages.moveout.status.unknown': 'Unknown',

  // 详情模态框
  'pages.moveout.detail.title': 'Move-out Registration Details',
  'pages.moveout.detail.sections.houseInfo': 'Property Information',
  'pages.moveout.detail.sections.applicantInfo': 'Applicant Information',
  'pages.moveout.detail.sections.moveoutInfo': 'Move-out Information',
  'pages.moveout.detail.sections.remarks': 'Remarks',
  'pages.moveout.detail.sections.systemInfo': 'System Information',

  // 字段标签
  'pages.moveout.detail.fields.buildingName': 'Building Name',
  'pages.moveout.detail.fields.floor': 'Floor',
  'pages.moveout.detail.fields.houseNumber': 'House Number',
  'pages.moveout.detail.fields.applicantName': 'Applicant Name',
  'pages.moveout.detail.fields.applicantPhone': 'Applicant Phone',
  'pages.moveout.detail.fields.ownerName': 'Owner Name',
  'pages.moveout.detail.fields.ownerPhone': 'Owner Phone',
  'pages.moveout.detail.fields.startDate': 'Move-out Start Date',
  'pages.moveout.detail.fields.endDate': 'Move-out End Date',
  'pages.moveout.detail.fields.moveoutList': 'Move-out List',
  'pages.moveout.detail.fields.moveoutStatus': 'Move-out Status',
  'pages.moveout.detail.fields.remarks': 'Remarks',
  'pages.moveout.detail.fields.createdTime': 'Created Time',
  'pages.moveout.detail.fields.updatedTime': 'Updated Time',

  // 编辑/创建表单
  'pages.moveout.form.create.title': 'New Move-out Registration',
  'pages.moveout.form.edit.title': 'Edit Move-out Registration',
  'pages.moveout.form.submit.create': 'Create',
  'pages.moveout.form.submit.update': 'Update',
  'pages.moveout.form.submit.cancel': 'Cancel',

  // 表单分区
  'pages.moveout.form.sections.houseInfo': 'Property Information',
  'pages.moveout.form.sections.moveoutInfo': 'Move-out Information',
  'pages.moveout.form.sections.moveoutList': 'Move-out List',
  'pages.moveout.form.sections.remarks': 'Remarks',

  // 表单字段
  'pages.moveout.form.fields.houseInfo.label': 'Property Information',
  'pages.moveout.form.fields.houseInfo.placeholder': 'Please select property',
  'pages.moveout.form.fields.houseInfo.search': 'Search',
  'pages.moveout.form.fields.houseInfo.select': 'Auto-filled after property selection',
  'pages.moveout.form.fields.houseInfo.required': 'Please select property',

  'pages.moveout.form.fields.ownerInfo.label': 'Owner Name',
  'pages.moveout.form.fields.ownerInfo.placeholder': 'Auto-filled after property selection',

  'pages.moveout.form.fields.applicantName.label': 'Applicant Name',
  'pages.moveout.form.fields.applicantName.placeholder': 'Please enter applicant name',
  'pages.moveout.form.fields.applicantName.required': 'Please enter applicant name',
  'pages.moveout.form.fields.applicantName.maxLength': 'Applicant name cannot exceed 50 characters',

  'pages.moveout.form.fields.applicantPhone.label': 'Applicant Phone',
  'pages.moveout.form.fields.applicantPhone.placeholder': 'Please enter applicant phone',
  'pages.moveout.form.fields.applicantPhone.required': 'Please enter applicant phone',

  'pages.moveout.form.fields.moveoutTime.label': 'Move-out Time',
  'pages.moveout.form.fields.moveoutTime.placeholder': ['Start Date', 'End Date'],
  'pages.moveout.form.fields.moveoutTime.required': 'Please select move-out time',

  'pages.moveout.form.fields.moveoutList.label': 'Move-out List',
  'pages.moveout.form.fields.moveoutList.required': 'Please add at least one move-out item',
  'pages.moveout.form.fields.moveoutList.notEmpty': 'Move-out items cannot be empty',
  'pages.moveout.form.fields.moveoutList.placeholder': 'Please enter list content',

  'pages.moveout.form.fields.remarks.label': 'Remarks',
  'pages.moveout.form.fields.remarks.placeholder': 'Please enter remarks',

  // 表格列
  'pages.moveout.form.table.columns.serialNumber': 'No.',
  'pages.moveout.form.table.columns.content': 'Content',
  'pages.moveout.form.table.columns.action': 'Action',

  // 按钮
  'pages.moveout.form.button.addItem': 'Add Item',
  'pages.moveout.form.button.delete': 'Delete',

  // 消息提示
  'pages.moveout.message.create.success': 'Move-out registration created successfully',
  'pages.moveout.message.create.failed': 'Creation failed, please try again later',
  'pages.moveout.message.update.success': 'Move-out registration updated successfully',
  'pages.moveout.message.update.failed': 'Update failed, please try again later',
  'pages.moveout.message.delete.success': 'Deleted successfully',
  'pages.moveout.message.delete.failed': 'Deletion failed',
  'pages.moveout.message.batchDelete.success': 'Batch deletion successful',
  'pages.moveout.message.batchDelete.failed': 'Batch deletion failed',
  'pages.moveout.message.houseSelect.success': 'Property information auto-filled',
  'pages.moveout.message.qrCode.configError': 'QR code URL configuration incomplete',
  'pages.moveout.message.qrCode.downloadSuccess': 'QR code downloaded',
  'pages.moveout.message.qrCode.copySuccess': 'QR code copied to clipboard',
  'pages.moveout.message.qrCode.copyFailed': 'Copy failed, please use download function',
  'pages.moveout.message.qrCode.elementNotFound': 'QR code element not found',
  'pages.moveout.message.qrCode.copyFailedAlternative': 'Copy failed, please use download function or try manual operation',
  'pages.moveout.message.listLoadFailed': 'Failed to load move-out registration list',

  // 确认对话框
  'pages.moveout.confirm.delete': 'Are you sure you want to delete this move-out registration?',
  'pages.moveout.confirm.deleteItem': 'Are you sure you want to delete this item?',
  'pages.moveout.confirm.batchDelete': 'Are you sure you want to delete the selected {count} records?',
  'pages.moveout.confirm.delete.okText': 'Confirm',
  'pages.moveout.confirm.delete.cancelText': 'Cancel',

  // 二维码相关
  'pages.moveout.qrCode.title': 'Move-out Registration QR Code',
  'pages.moveout.qrCode.openLink': 'Open Link',
  'pages.moveout.qrCode.copy': 'Copy QR Code',
  'pages.moveout.qrCode.download': 'Download QR Code',
  'pages.moveout.qrCode.linkLabel': 'Link URL:',

  // 表格分页
  'pages.moveout.table.pagination.total': 'Total {total} records',

  // Tooltip
  'pages.moveout.tooltip.viewDetail': 'View Details',
  'pages.moveout.tooltip.edit': 'Edit',
  'pages.moveout.tooltip.delete': 'Delete',
  'pages.moveout.tooltip.generateQrCode': 'Generate QR Code',

  // Warning messages
  'pages.moveout.warning.selectRecords': 'Please select records to delete',
};
